import { api } from 'api'
import { WorkStatusEnum } from './shiftTimeline'

type GetLeadShiftsRequest = {
  companyId: number
  shiftId: number
}

type GetLeadShiftsResponseLeadShiftWork = {
  status: WorkStatusEnum
  worker: {
    id: number
    name: string
    profilePicUrl?: string
  }
  confirmedAt?: string
  startedAt?: string
  supervisorMarkedNoShow?: boolean
}

type GetLeadShiftsResponseLeadShift = {
  id: number
  startsAt: string
  endsAt: string
  workersNeeded: number
  position: {
    id: number
    name: string
  }
  location?: {
    id: number
    name: string
    timezone?: string
  }
  work: GetLeadShiftsResponseLeadShiftWork[]
}

type GetLeadShiftsResponse = {
  leadShifts: GetLeadShiftsResponseLeadShift[]
  canCreateLeadShifts: boolean
  leadCompanyId?: number
  defaultLeadPositionId?: number
  hasLeadPosition: boolean
  paymentType: 'hourly' | 'lump_sum'
  hasBillRate: boolean
}

export async function getLeadShifts(
  { companyId, shiftId }: GetLeadShiftsRequest,
  signal?: AbortSignal
) {
  const response = await api.get<GetLeadShiftsResponse>(
    `/company/${companyId}/shifts/${shiftId}/lead_shifts`,
    { signal }
  )

  return response.data
}

type CreateLeadShiftsRequest = {
  companyId: number
  shiftId: number
  leadPositionId?: number
  shiftLeadsNeeded: number
  earlyStartInMinutes: number
  laterEndInMinutes: number
  payRate?: number
  payLumpSum?: number
}

type CreateLeadShiftsResponse = {
  leadShiftIds: number[]
}

export async function createLeadShifts({
  companyId,
  shiftId,
  leadPositionId,
  shiftLeadsNeeded,
  earlyStartInMinutes,
  laterEndInMinutes,
  payRate,
  payLumpSum,
}: CreateLeadShiftsRequest) {
  const body: Omit<CreateLeadShiftsRequest, 'companyId' | 'shiftId'> = {
    leadPositionId,
    shiftLeadsNeeded,
    earlyStartInMinutes,
    laterEndInMinutes,
    payRate,
    payLumpSum,
  }
  const response = await api.post<CreateLeadShiftsResponse>(
    `/company/${companyId}/shifts/${shiftId}/lead_shifts`,
    body
  )

  return response.data
}
